/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SuperSingleRouteImport } from './routes/super-single'
import { Route as StemsRouteImport } from './routes/stems'
import { Route as SellMusicOnlineRouteImport } from './routes/sell-music-online'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MotionArtRouteImport } from './routes/motion-art'
import { Route as MasteringRouteImport } from './routes/mastering'
import { Route as LyricsRouteImport } from './routes/lyrics'
import { Route as LyricVideoRouteImport } from './routes/lyric-video'
import { Route as LibsRouteImport } from './routes/libs'
import { Route as LabelsRouteImport } from './routes/labels'
import { Route as EnhancedAlbumRouteImport } from './routes/enhanced-album'
import { Route as DmcaRouteImport } from './routes/dmca'
import { Route as CoverArtRouteImport } from './routes/cover-art'
import { Route as CleancutRouteImport } from './routes/cleancut'
import { Route as ArtistsRouteImport } from './routes/artists'
import { Route as AcceptableUseRouteImport } from './routes/acceptable-use'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AudiolabRouteRouteImport } from './routes/audiolab/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UpgradeIndexRouteImport } from './routes/upgrade/index'
import { Route as ForArtistsIndexRouteImport } from './routes/for-artists/index'
import { Route as FansIndexRouteImport } from './routes/fans/index'
import { Route as AudiolabIndexRouteImport } from './routes/audiolab/index'
import { Route as AtChar123CREATOR_SLUGChar125IndexRouteImport } from './routes/@{$CREATOR_SLUG}/index'
import { Route as TracksTRACK_IDRouteImport } from './routes/tracks/$TRACK_ID'
import { Route as SoundkitsSOUNDKIT_IDRouteImport } from './routes/soundkits/$SOUNDKIT_ID'
import { Route as Oauth2IdpresponseRouteImport } from './routes/oauth2/idpresponse'
import { Route as MarketplaceLayoutRouteImport } from './routes/marketplace/_layout'
import { Route as CreatorsMeRouteImport } from './routes/creators/me'
import { Route as CreatorsCREATOR_IDRouteImport } from './routes/creators/$CREATOR_ID'
import { Route as CheckoutRedirectRouteImport } from './routes/checkout/redirect'
import { Route as AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2RouteImport } from './routes/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
import { Route as AudiolabSalesRouteImport } from './routes/audiolab/sales'
import { Route as AudiolabHelpRouteImport } from './routes/audiolab/help'
import { Route as AlbumsALBUM_IDRouteImport } from './routes/albums/$ALBUM_ID'
import { Route as AccountPurchasesRouteImport } from './routes/account/purchases'
import { Route as AccountLikedSongsRouteImport } from './routes/account/liked-songs'
import { Route as AccountFollowedArtistsRouteImport } from './routes/account/followed-artists'
import { Route as AtChar123CREATOR_SLUGChar125ALBUM_SLUGRouteImport } from './routes/@{$CREATOR_SLUG}/$ALBUM_SLUG'
import { Route as DevDevLayoutRouteRouteImport } from './routes/dev/_devLayout/route'
import { Route as AuthAuthLayoutRouteRouteImport } from './routes/auth/_authLayout/route'
import { Route as AdminAdminLayoutRouteRouteImport } from './routes/admin/_adminLayout/route'
import { Route as AccountSettingsRouteRouteImport } from './routes/account/settings/route'
import { Route as MarketplaceLayoutIndexRouteImport } from './routes/marketplace/_layout/index'
import { Route as AudiolabRosterIndexRouteImport } from './routes/audiolab/roster/index'
import { Route as AudiolabReleasesIndexRouteImport } from './routes/audiolab/releases/index'
import { Route as AudiolabAlbumsIndexRouteImport } from './routes/audiolab/albums/index'
import { Route as AdminAdminLayoutIndexRouteImport } from './routes/admin/_adminLayout/index'
import { Route as MarketplaceLayoutSoundkitsRouteImport } from './routes/marketplace/_layout/soundkits'
import { Route as MarketplaceLayoutSongsRouteImport } from './routes/marketplace/_layout/songs'
import { Route as MarketplaceLayoutBeatsRouteImport } from './routes/marketplace/_layout/beats'
import { Route as MarketplaceLayoutAlbumsRouteImport } from './routes/marketplace/_layout/albums'
import { Route as DevDevLayoutWaveformTestRouteImport } from './routes/dev/_devLayout/waveform-test'
import { Route as DevDevLayoutGlobalPlayerTestRouteImport } from './routes/dev/_devLayout/global-player-test'
import { Route as DevDevLayoutDdTestRouteImport } from './routes/dev/_devLayout/dd-test'
import { Route as DevDevLayoutAudioTestRouteImport } from './routes/dev/_devLayout/audio-test'
import { Route as AuthAuthLayoutVerifyEmailRouteImport } from './routes/auth/_authLayout/verify-email'
import { Route as AuthAuthLayoutResetPasswordRouteImport } from './routes/auth/_authLayout/reset-password'
import { Route as AudiolabSoundkitsSOUNDKIT_IDRouteImport } from './routes/audiolab/soundkits/$SOUNDKIT_ID'
import { Route as AudiolabReleasesALBUM_IDRouteImport } from './routes/audiolab/releases/$ALBUM_ID'
import { Route as AudiolabCreatorsCREATOR_IDRouteImport } from './routes/audiolab/creators/$CREATOR_ID'
import { Route as AudiolabAlbumsALBUM_IDRouteImport } from './routes/audiolab/albums/$ALBUM_ID'
import { Route as AdminAdminLayoutUsersRouteImport } from './routes/admin/_adminLayout/users'
import { Route as AdminAdminLayoutImpersonateRouteImport } from './routes/admin/_adminLayout/impersonate'
import { Route as AdminAdminLayoutFeaturedAlbumsRouteImport } from './routes/admin/_adminLayout/featured-albums'
import { Route as AdminAdminLayoutDeleteUserRouteImport } from './routes/admin/_adminLayout/delete-user'
import { Route as AccountSettingsPlanRouteImport } from './routes/account/settings/plan'
import { Route as AccountSettingsPersonalRouteImport } from './routes/account/settings/personal'
import { Route as AccountSettingsBillingRouteImport } from './routes/account/settings/billing'
import { Route as AudiolabTracksTRACK_IDIndexRouteImport } from './routes/audiolab/tracks/$TRACK_ID/index'
import { Route as AudiolabTracksTRACK_IDLyricsVideoRouteImport } from './routes/audiolab/tracks/$TRACK_ID/lyrics-video'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperSingleRoute = SuperSingleRouteImport.update({
  id: '/super-single',
  path: '/super-single',
  getParentRoute: () => rootRouteImport,
} as any)
const StemsRoute = StemsRouteImport.update({
  id: '/stems',
  path: '/stems',
  getParentRoute: () => rootRouteImport,
} as any)
const SellMusicOnlineRoute = SellMusicOnlineRouteImport.update({
  id: '/sell-music-online',
  path: '/sell-music-online',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MotionArtRoute = MotionArtRouteImport.update({
  id: '/motion-art',
  path: '/motion-art',
  getParentRoute: () => rootRouteImport,
} as any)
const MasteringRoute = MasteringRouteImport.update({
  id: '/mastering',
  path: '/mastering',
  getParentRoute: () => rootRouteImport,
} as any)
const LyricsRoute = LyricsRouteImport.update({
  id: '/lyrics',
  path: '/lyrics',
  getParentRoute: () => rootRouteImport,
} as any)
const LyricVideoRoute = LyricVideoRouteImport.update({
  id: '/lyric-video',
  path: '/lyric-video',
  getParentRoute: () => rootRouteImport,
} as any)
const LibsRoute = LibsRouteImport.update({
  id: '/libs',
  path: '/libs',
  getParentRoute: () => rootRouteImport,
} as any)
const LabelsRoute = LabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const EnhancedAlbumRoute = EnhancedAlbumRouteImport.update({
  id: '/enhanced-album',
  path: '/enhanced-album',
  getParentRoute: () => rootRouteImport,
} as any)
const DmcaRoute = DmcaRouteImport.update({
  id: '/dmca',
  path: '/dmca',
  getParentRoute: () => rootRouteImport,
} as any)
const CoverArtRoute = CoverArtRouteImport.update({
  id: '/cover-art',
  path: '/cover-art',
  getParentRoute: () => rootRouteImport,
} as any)
const CleancutRoute = CleancutRouteImport.update({
  id: '/cleancut',
  path: '/cleancut',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtistsRoute = ArtistsRouteImport.update({
  id: '/artists',
  path: '/artists',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptableUseRoute = AcceptableUseRouteImport.update({
  id: '/acceptable-use',
  path: '/acceptable-use',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutUsRoute = AboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AudiolabRouteRoute = AudiolabRouteRouteImport.update({
  id: '/audiolab',
  path: '/audiolab',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeIndexRoute = UpgradeIndexRouteImport.update({
  id: '/upgrade/',
  path: '/upgrade/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForArtistsIndexRoute = ForArtistsIndexRouteImport.update({
  id: '/for-artists/',
  path: '/for-artists/',
  getParentRoute: () => rootRouteImport,
} as any)
const FansIndexRoute = FansIndexRouteImport.update({
  id: '/fans/',
  path: '/fans/',
  getParentRoute: () => rootRouteImport,
} as any)
const AudiolabIndexRoute = AudiolabIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AtChar123CREATOR_SLUGChar125IndexRoute =
  AtChar123CREATOR_SLUGChar125IndexRouteImport.update({
    id: '/@{$CREATOR_SLUG}/',
    path: '/@{$CREATOR_SLUG}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TracksTRACK_IDRoute = TracksTRACK_IDRouteImport.update({
  id: '/tracks/$TRACK_ID',
  path: '/tracks/$TRACK_ID',
  getParentRoute: () => rootRouteImport,
} as any)
const SoundkitsSOUNDKIT_IDRoute = SoundkitsSOUNDKIT_IDRouteImport.update({
  id: '/soundkits/$SOUNDKIT_ID',
  path: '/soundkits/$SOUNDKIT_ID',
  getParentRoute: () => rootRouteImport,
} as any)
const Oauth2IdpresponseRoute = Oauth2IdpresponseRouteImport.update({
  id: '/oauth2/idpresponse',
  path: '/oauth2/idpresponse',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceLayoutRoute = MarketplaceLayoutRouteImport.update({
  id: '/marketplace/_layout',
  path: '/marketplace',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorsMeRoute = CreatorsMeRouteImport.update({
  id: '/creators/me',
  path: '/creators/me',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorsCREATOR_IDRoute = CreatorsCREATOR_IDRouteImport.update({
  id: '/creators/$CREATOR_ID',
  path: '/creators/$CREATOR_ID',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRedirectRoute = CheckoutRedirectRouteImport.update({
  id: '/checkout/redirect',
  path: '/checkout/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route =
  AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2RouteImport.update({
    id: '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2',
    path: '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2',
    getParentRoute: () => rootRouteImport,
  } as any)
const AudiolabSalesRoute = AudiolabSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AudiolabHelpRoute = AudiolabHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AlbumsALBUM_IDRoute = AlbumsALBUM_IDRouteImport.update({
  id: '/albums/$ALBUM_ID',
  path: '/albums/$ALBUM_ID',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountPurchasesRoute = AccountPurchasesRouteImport.update({
  id: '/account/purchases',
  path: '/account/purchases',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountLikedSongsRoute = AccountLikedSongsRouteImport.update({
  id: '/account/liked-songs',
  path: '/account/liked-songs',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountFollowedArtistsRoute = AccountFollowedArtistsRouteImport.update({
  id: '/account/followed-artists',
  path: '/account/followed-artists',
  getParentRoute: () => rootRouteImport,
} as any)
const AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute =
  AtChar123CREATOR_SLUGChar125ALBUM_SLUGRouteImport.update({
    id: '/@{$CREATOR_SLUG}/$ALBUM_SLUG',
    path: '/@{$CREATOR_SLUG}/$ALBUM_SLUG',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevDevLayoutRouteRoute = DevDevLayoutRouteRouteImport.update({
  id: '/dev/_devLayout',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthLayoutRouteRoute = AuthAuthLayoutRouteRouteImport.update({
  id: '/auth/_authLayout',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminLayoutRouteRoute = AdminAdminLayoutRouteRouteImport.update({
  id: '/admin/_adminLayout',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSettingsRouteRoute = AccountSettingsRouteRouteImport.update({
  id: '/account/settings',
  path: '/account/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceLayoutIndexRoute = MarketplaceLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketplaceLayoutRoute,
} as any)
const AudiolabRosterIndexRoute = AudiolabRosterIndexRouteImport.update({
  id: '/roster/',
  path: '/roster/',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AudiolabReleasesIndexRoute = AudiolabReleasesIndexRouteImport.update({
  id: '/releases/',
  path: '/releases/',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AudiolabAlbumsIndexRoute = AudiolabAlbumsIndexRouteImport.update({
  id: '/albums/',
  path: '/albums/',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AdminAdminLayoutIndexRoute = AdminAdminLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAdminLayoutRouteRoute,
} as any)
const MarketplaceLayoutSoundkitsRoute =
  MarketplaceLayoutSoundkitsRouteImport.update({
    id: '/soundkits',
    path: '/soundkits',
    getParentRoute: () => MarketplaceLayoutRoute,
  } as any)
const MarketplaceLayoutSongsRoute = MarketplaceLayoutSongsRouteImport.update({
  id: '/songs',
  path: '/songs',
  getParentRoute: () => MarketplaceLayoutRoute,
} as any)
const MarketplaceLayoutBeatsRoute = MarketplaceLayoutBeatsRouteImport.update({
  id: '/beats',
  path: '/beats',
  getParentRoute: () => MarketplaceLayoutRoute,
} as any)
const MarketplaceLayoutAlbumsRoute = MarketplaceLayoutAlbumsRouteImport.update({
  id: '/albums',
  path: '/albums',
  getParentRoute: () => MarketplaceLayoutRoute,
} as any)
const DevDevLayoutWaveformTestRoute =
  DevDevLayoutWaveformTestRouteImport.update({
    id: '/waveform-test',
    path: '/waveform-test',
    getParentRoute: () => DevDevLayoutRouteRoute,
  } as any)
const DevDevLayoutGlobalPlayerTestRoute =
  DevDevLayoutGlobalPlayerTestRouteImport.update({
    id: '/global-player-test',
    path: '/global-player-test',
    getParentRoute: () => DevDevLayoutRouteRoute,
  } as any)
const DevDevLayoutDdTestRoute = DevDevLayoutDdTestRouteImport.update({
  id: '/dd-test',
  path: '/dd-test',
  getParentRoute: () => DevDevLayoutRouteRoute,
} as any)
const DevDevLayoutAudioTestRoute = DevDevLayoutAudioTestRouteImport.update({
  id: '/audio-test',
  path: '/audio-test',
  getParentRoute: () => DevDevLayoutRouteRoute,
} as any)
const AuthAuthLayoutVerifyEmailRoute =
  AuthAuthLayoutVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => AuthAuthLayoutRouteRoute,
  } as any)
const AuthAuthLayoutResetPasswordRoute =
  AuthAuthLayoutResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthAuthLayoutRouteRoute,
  } as any)
const AudiolabSoundkitsSOUNDKIT_IDRoute =
  AudiolabSoundkitsSOUNDKIT_IDRouteImport.update({
    id: '/soundkits/$SOUNDKIT_ID',
    path: '/soundkits/$SOUNDKIT_ID',
    getParentRoute: () => AudiolabRouteRoute,
  } as any)
const AudiolabReleasesALBUM_IDRoute =
  AudiolabReleasesALBUM_IDRouteImport.update({
    id: '/releases/$ALBUM_ID',
    path: '/releases/$ALBUM_ID',
    getParentRoute: () => AudiolabRouteRoute,
  } as any)
const AudiolabCreatorsCREATOR_IDRoute =
  AudiolabCreatorsCREATOR_IDRouteImport.update({
    id: '/creators/$CREATOR_ID',
    path: '/creators/$CREATOR_ID',
    getParentRoute: () => AudiolabRouteRoute,
  } as any)
const AudiolabAlbumsALBUM_IDRoute = AudiolabAlbumsALBUM_IDRouteImport.update({
  id: '/albums/$ALBUM_ID',
  path: '/albums/$ALBUM_ID',
  getParentRoute: () => AudiolabRouteRoute,
} as any)
const AdminAdminLayoutUsersRoute = AdminAdminLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminAdminLayoutRouteRoute,
} as any)
const AdminAdminLayoutImpersonateRoute =
  AdminAdminLayoutImpersonateRouteImport.update({
    id: '/impersonate',
    path: '/impersonate',
    getParentRoute: () => AdminAdminLayoutRouteRoute,
  } as any)
const AdminAdminLayoutFeaturedAlbumsRoute =
  AdminAdminLayoutFeaturedAlbumsRouteImport.update({
    id: '/featured-albums',
    path: '/featured-albums',
    getParentRoute: () => AdminAdminLayoutRouteRoute,
  } as any)
const AdminAdminLayoutDeleteUserRoute =
  AdminAdminLayoutDeleteUserRouteImport.update({
    id: '/delete-user',
    path: '/delete-user',
    getParentRoute: () => AdminAdminLayoutRouteRoute,
  } as any)
const AccountSettingsPlanRoute = AccountSettingsPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AccountSettingsRouteRoute,
} as any)
const AccountSettingsPersonalRoute = AccountSettingsPersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => AccountSettingsRouteRoute,
} as any)
const AccountSettingsBillingRoute = AccountSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AccountSettingsRouteRoute,
} as any)
const AudiolabTracksTRACK_IDIndexRoute =
  AudiolabTracksTRACK_IDIndexRouteImport.update({
    id: '/tracks/$TRACK_ID/',
    path: '/tracks/$TRACK_ID/',
    getParentRoute: () => AudiolabRouteRoute,
  } as any)
const AudiolabTracksTRACK_IDLyricsVideoRoute =
  AudiolabTracksTRACK_IDLyricsVideoRouteImport.update({
    id: '/tracks/$TRACK_ID/lyrics-video',
    path: '/tracks/$TRACK_ID/lyrics-video',
    getParentRoute: () => AudiolabRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audiolab': typeof AudiolabRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/about-us': typeof AboutUsRoute
  '/acceptable-use': typeof AcceptableUseRoute
  '/artists': typeof ArtistsRoute
  '/cleancut': typeof CleancutRoute
  '/cover-art': typeof CoverArtRoute
  '/dmca': typeof DmcaRoute
  '/enhanced-album': typeof EnhancedAlbumRoute
  '/labels': typeof LabelsRoute
  '/libs': typeof LibsRoute
  '/lyric-video': typeof LyricVideoRoute
  '/lyrics': typeof LyricsRoute
  '/mastering': typeof MasteringRoute
  '/motion-art': typeof MotionArtRoute
  '/privacy': typeof PrivacyRoute
  '/sell-music-online': typeof SellMusicOnlineRoute
  '/stems': typeof StemsRoute
  '/super-single': typeof SuperSingleRoute
  '/terms': typeof TermsRoute
  '/account/settings': typeof AccountSettingsRouteRouteWithChildren
  '/admin': typeof AdminAdminLayoutRouteRouteWithChildren
  '/auth': typeof AuthAuthLayoutRouteRouteWithChildren
  '/dev': typeof DevDevLayoutRouteRouteWithChildren
  '/@{$CREATOR_SLUG}/$ALBUM_SLUG': typeof AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute
  '/account/followed-artists': typeof AccountFollowedArtistsRoute
  '/account/liked-songs': typeof AccountLikedSongsRoute
  '/account/purchases': typeof AccountPurchasesRoute
  '/albums/$ALBUM_ID': typeof AlbumsALBUM_IDRoute
  '/audiolab/help': typeof AudiolabHelpRoute
  '/audiolab/sales': typeof AudiolabSalesRoute
  '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2': typeof AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route
  '/checkout/redirect': typeof CheckoutRedirectRoute
  '/creators/$CREATOR_ID': typeof CreatorsCREATOR_IDRoute
  '/creators/me': typeof CreatorsMeRoute
  '/marketplace': typeof MarketplaceLayoutRouteWithChildren
  '/oauth2/idpresponse': typeof Oauth2IdpresponseRoute
  '/soundkits/$SOUNDKIT_ID': typeof SoundkitsSOUNDKIT_IDRoute
  '/tracks/$TRACK_ID': typeof TracksTRACK_IDRoute
  '/@{$CREATOR_SLUG}/': typeof AtChar123CREATOR_SLUGChar125IndexRoute
  '/audiolab/': typeof AudiolabIndexRoute
  '/fans/': typeof FansIndexRoute
  '/for-artists/': typeof ForArtistsIndexRoute
  '/upgrade/': typeof UpgradeIndexRoute
  '/account/settings/billing': typeof AccountSettingsBillingRoute
  '/account/settings/personal': typeof AccountSettingsPersonalRoute
  '/account/settings/plan': typeof AccountSettingsPlanRoute
  '/admin/delete-user': typeof AdminAdminLayoutDeleteUserRoute
  '/admin/featured-albums': typeof AdminAdminLayoutFeaturedAlbumsRoute
  '/admin/impersonate': typeof AdminAdminLayoutImpersonateRoute
  '/admin/users': typeof AdminAdminLayoutUsersRoute
  '/audiolab/albums/$ALBUM_ID': typeof AudiolabAlbumsALBUM_IDRoute
  '/audiolab/creators/$CREATOR_ID': typeof AudiolabCreatorsCREATOR_IDRoute
  '/audiolab/releases/$ALBUM_ID': typeof AudiolabReleasesALBUM_IDRoute
  '/audiolab/soundkits/$SOUNDKIT_ID': typeof AudiolabSoundkitsSOUNDKIT_IDRoute
  '/auth/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/auth/verify-email': typeof AuthAuthLayoutVerifyEmailRoute
  '/dev/audio-test': typeof DevDevLayoutAudioTestRoute
  '/dev/dd-test': typeof DevDevLayoutDdTestRoute
  '/dev/global-player-test': typeof DevDevLayoutGlobalPlayerTestRoute
  '/dev/waveform-test': typeof DevDevLayoutWaveformTestRoute
  '/marketplace/albums': typeof MarketplaceLayoutAlbumsRoute
  '/marketplace/beats': typeof MarketplaceLayoutBeatsRoute
  '/marketplace/songs': typeof MarketplaceLayoutSongsRoute
  '/marketplace/soundkits': typeof MarketplaceLayoutSoundkitsRoute
  '/admin/': typeof AdminAdminLayoutIndexRoute
  '/audiolab/albums/': typeof AudiolabAlbumsIndexRoute
  '/audiolab/releases/': typeof AudiolabReleasesIndexRoute
  '/audiolab/roster/': typeof AudiolabRosterIndexRoute
  '/marketplace/': typeof MarketplaceLayoutIndexRoute
  '/audiolab/tracks/$TRACK_ID/lyrics-video': typeof AudiolabTracksTRACK_IDLyricsVideoRoute
  '/audiolab/tracks/$TRACK_ID/': typeof AudiolabTracksTRACK_IDIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/about-us': typeof AboutUsRoute
  '/acceptable-use': typeof AcceptableUseRoute
  '/artists': typeof ArtistsRoute
  '/cleancut': typeof CleancutRoute
  '/cover-art': typeof CoverArtRoute
  '/dmca': typeof DmcaRoute
  '/enhanced-album': typeof EnhancedAlbumRoute
  '/labels': typeof LabelsRoute
  '/libs': typeof LibsRoute
  '/lyric-video': typeof LyricVideoRoute
  '/lyrics': typeof LyricsRoute
  '/mastering': typeof MasteringRoute
  '/motion-art': typeof MotionArtRoute
  '/privacy': typeof PrivacyRoute
  '/sell-music-online': typeof SellMusicOnlineRoute
  '/stems': typeof StemsRoute
  '/super-single': typeof SuperSingleRoute
  '/terms': typeof TermsRoute
  '/account/settings': typeof AccountSettingsRouteRouteWithChildren
  '/auth': typeof AuthAuthLayoutRouteRouteWithChildren
  '/dev': typeof DevDevLayoutRouteRouteWithChildren
  '/@{$CREATOR_SLUG}/$ALBUM_SLUG': typeof AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute
  '/account/followed-artists': typeof AccountFollowedArtistsRoute
  '/account/liked-songs': typeof AccountLikedSongsRoute
  '/account/purchases': typeof AccountPurchasesRoute
  '/albums/$ALBUM_ID': typeof AlbumsALBUM_IDRoute
  '/audiolab/help': typeof AudiolabHelpRoute
  '/audiolab/sales': typeof AudiolabSalesRoute
  '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2': typeof AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route
  '/checkout/redirect': typeof CheckoutRedirectRoute
  '/creators/$CREATOR_ID': typeof CreatorsCREATOR_IDRoute
  '/creators/me': typeof CreatorsMeRoute
  '/oauth2/idpresponse': typeof Oauth2IdpresponseRoute
  '/soundkits/$SOUNDKIT_ID': typeof SoundkitsSOUNDKIT_IDRoute
  '/tracks/$TRACK_ID': typeof TracksTRACK_IDRoute
  '/@{$CREATOR_SLUG}': typeof AtChar123CREATOR_SLUGChar125IndexRoute
  '/audiolab': typeof AudiolabIndexRoute
  '/fans': typeof FansIndexRoute
  '/for-artists': typeof ForArtistsIndexRoute
  '/upgrade': typeof UpgradeIndexRoute
  '/account/settings/billing': typeof AccountSettingsBillingRoute
  '/account/settings/personal': typeof AccountSettingsPersonalRoute
  '/account/settings/plan': typeof AccountSettingsPlanRoute
  '/admin/delete-user': typeof AdminAdminLayoutDeleteUserRoute
  '/admin/featured-albums': typeof AdminAdminLayoutFeaturedAlbumsRoute
  '/admin/impersonate': typeof AdminAdminLayoutImpersonateRoute
  '/admin/users': typeof AdminAdminLayoutUsersRoute
  '/audiolab/albums/$ALBUM_ID': typeof AudiolabAlbumsALBUM_IDRoute
  '/audiolab/creators/$CREATOR_ID': typeof AudiolabCreatorsCREATOR_IDRoute
  '/audiolab/releases/$ALBUM_ID': typeof AudiolabReleasesALBUM_IDRoute
  '/audiolab/soundkits/$SOUNDKIT_ID': typeof AudiolabSoundkitsSOUNDKIT_IDRoute
  '/auth/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/auth/verify-email': typeof AuthAuthLayoutVerifyEmailRoute
  '/dev/audio-test': typeof DevDevLayoutAudioTestRoute
  '/dev/dd-test': typeof DevDevLayoutDdTestRoute
  '/dev/global-player-test': typeof DevDevLayoutGlobalPlayerTestRoute
  '/dev/waveform-test': typeof DevDevLayoutWaveformTestRoute
  '/marketplace/albums': typeof MarketplaceLayoutAlbumsRoute
  '/marketplace/beats': typeof MarketplaceLayoutBeatsRoute
  '/marketplace/songs': typeof MarketplaceLayoutSongsRoute
  '/marketplace/soundkits': typeof MarketplaceLayoutSoundkitsRoute
  '/admin': typeof AdminAdminLayoutIndexRoute
  '/audiolab/albums': typeof AudiolabAlbumsIndexRoute
  '/audiolab/releases': typeof AudiolabReleasesIndexRoute
  '/audiolab/roster': typeof AudiolabRosterIndexRoute
  '/marketplace': typeof MarketplaceLayoutIndexRoute
  '/audiolab/tracks/$TRACK_ID/lyrics-video': typeof AudiolabTracksTRACK_IDLyricsVideoRoute
  '/audiolab/tracks/$TRACK_ID': typeof AudiolabTracksTRACK_IDIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audiolab': typeof AudiolabRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/about-us': typeof AboutUsRoute
  '/acceptable-use': typeof AcceptableUseRoute
  '/artists': typeof ArtistsRoute
  '/cleancut': typeof CleancutRoute
  '/cover-art': typeof CoverArtRoute
  '/dmca': typeof DmcaRoute
  '/enhanced-album': typeof EnhancedAlbumRoute
  '/labels': typeof LabelsRoute
  '/libs': typeof LibsRoute
  '/lyric-video': typeof LyricVideoRoute
  '/lyrics': typeof LyricsRoute
  '/mastering': typeof MasteringRoute
  '/motion-art': typeof MotionArtRoute
  '/privacy': typeof PrivacyRoute
  '/sell-music-online': typeof SellMusicOnlineRoute
  '/stems': typeof StemsRoute
  '/super-single': typeof SuperSingleRoute
  '/terms': typeof TermsRoute
  '/account/settings': typeof AccountSettingsRouteRouteWithChildren
  '/admin/_adminLayout': typeof AdminAdminLayoutRouteRouteWithChildren
  '/auth/_authLayout': typeof AuthAuthLayoutRouteRouteWithChildren
  '/dev/_devLayout': typeof DevDevLayoutRouteRouteWithChildren
  '/@{$CREATOR_SLUG}/$ALBUM_SLUG': typeof AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute
  '/account/followed-artists': typeof AccountFollowedArtistsRoute
  '/account/liked-songs': typeof AccountLikedSongsRoute
  '/account/purchases': typeof AccountPurchasesRoute
  '/albums/$ALBUM_ID': typeof AlbumsALBUM_IDRoute
  '/audiolab/help': typeof AudiolabHelpRoute
  '/audiolab/sales': typeof AudiolabSalesRoute
  '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2': typeof AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route
  '/checkout/redirect': typeof CheckoutRedirectRoute
  '/creators/$CREATOR_ID': typeof CreatorsCREATOR_IDRoute
  '/creators/me': typeof CreatorsMeRoute
  '/marketplace/_layout': typeof MarketplaceLayoutRouteWithChildren
  '/oauth2/idpresponse': typeof Oauth2IdpresponseRoute
  '/soundkits/$SOUNDKIT_ID': typeof SoundkitsSOUNDKIT_IDRoute
  '/tracks/$TRACK_ID': typeof TracksTRACK_IDRoute
  '/@{$CREATOR_SLUG}/': typeof AtChar123CREATOR_SLUGChar125IndexRoute
  '/audiolab/': typeof AudiolabIndexRoute
  '/fans/': typeof FansIndexRoute
  '/for-artists/': typeof ForArtistsIndexRoute
  '/upgrade/': typeof UpgradeIndexRoute
  '/account/settings/billing': typeof AccountSettingsBillingRoute
  '/account/settings/personal': typeof AccountSettingsPersonalRoute
  '/account/settings/plan': typeof AccountSettingsPlanRoute
  '/admin/_adminLayout/delete-user': typeof AdminAdminLayoutDeleteUserRoute
  '/admin/_adminLayout/featured-albums': typeof AdminAdminLayoutFeaturedAlbumsRoute
  '/admin/_adminLayout/impersonate': typeof AdminAdminLayoutImpersonateRoute
  '/admin/_adminLayout/users': typeof AdminAdminLayoutUsersRoute
  '/audiolab/albums/$ALBUM_ID': typeof AudiolabAlbumsALBUM_IDRoute
  '/audiolab/creators/$CREATOR_ID': typeof AudiolabCreatorsCREATOR_IDRoute
  '/audiolab/releases/$ALBUM_ID': typeof AudiolabReleasesALBUM_IDRoute
  '/audiolab/soundkits/$SOUNDKIT_ID': typeof AudiolabSoundkitsSOUNDKIT_IDRoute
  '/auth/_authLayout/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/auth/_authLayout/verify-email': typeof AuthAuthLayoutVerifyEmailRoute
  '/dev/_devLayout/audio-test': typeof DevDevLayoutAudioTestRoute
  '/dev/_devLayout/dd-test': typeof DevDevLayoutDdTestRoute
  '/dev/_devLayout/global-player-test': typeof DevDevLayoutGlobalPlayerTestRoute
  '/dev/_devLayout/waveform-test': typeof DevDevLayoutWaveformTestRoute
  '/marketplace/_layout/albums': typeof MarketplaceLayoutAlbumsRoute
  '/marketplace/_layout/beats': typeof MarketplaceLayoutBeatsRoute
  '/marketplace/_layout/songs': typeof MarketplaceLayoutSongsRoute
  '/marketplace/_layout/soundkits': typeof MarketplaceLayoutSoundkitsRoute
  '/admin/_adminLayout/': typeof AdminAdminLayoutIndexRoute
  '/audiolab/albums/': typeof AudiolabAlbumsIndexRoute
  '/audiolab/releases/': typeof AudiolabReleasesIndexRoute
  '/audiolab/roster/': typeof AudiolabRosterIndexRoute
  '/marketplace/_layout/': typeof MarketplaceLayoutIndexRoute
  '/audiolab/tracks/$TRACK_ID/lyrics-video': typeof AudiolabTracksTRACK_IDLyricsVideoRoute
  '/audiolab/tracks/$TRACK_ID/': typeof AudiolabTracksTRACK_IDIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audiolab'
    | '/about'
    | '/about-us'
    | '/acceptable-use'
    | '/artists'
    | '/cleancut'
    | '/cover-art'
    | '/dmca'
    | '/enhanced-album'
    | '/labels'
    | '/libs'
    | '/lyric-video'
    | '/lyrics'
    | '/mastering'
    | '/motion-art'
    | '/privacy'
    | '/sell-music-online'
    | '/stems'
    | '/super-single'
    | '/terms'
    | '/account/settings'
    | '/admin'
    | '/auth'
    | '/dev'
    | '/@{$CREATOR_SLUG}/$ALBUM_SLUG'
    | '/account/followed-artists'
    | '/account/liked-songs'
    | '/account/purchases'
    | '/albums/$ALBUM_ID'
    | '/audiolab/help'
    | '/audiolab/sales'
    | '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
    | '/checkout/redirect'
    | '/creators/$CREATOR_ID'
    | '/creators/me'
    | '/marketplace'
    | '/oauth2/idpresponse'
    | '/soundkits/$SOUNDKIT_ID'
    | '/tracks/$TRACK_ID'
    | '/@{$CREATOR_SLUG}/'
    | '/audiolab/'
    | '/fans/'
    | '/for-artists/'
    | '/upgrade/'
    | '/account/settings/billing'
    | '/account/settings/personal'
    | '/account/settings/plan'
    | '/admin/delete-user'
    | '/admin/featured-albums'
    | '/admin/impersonate'
    | '/admin/users'
    | '/audiolab/albums/$ALBUM_ID'
    | '/audiolab/creators/$CREATOR_ID'
    | '/audiolab/releases/$ALBUM_ID'
    | '/audiolab/soundkits/$SOUNDKIT_ID'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/dev/audio-test'
    | '/dev/dd-test'
    | '/dev/global-player-test'
    | '/dev/waveform-test'
    | '/marketplace/albums'
    | '/marketplace/beats'
    | '/marketplace/songs'
    | '/marketplace/soundkits'
    | '/admin/'
    | '/audiolab/albums/'
    | '/audiolab/releases/'
    | '/audiolab/roster/'
    | '/marketplace/'
    | '/audiolab/tracks/$TRACK_ID/lyrics-video'
    | '/audiolab/tracks/$TRACK_ID/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/about-us'
    | '/acceptable-use'
    | '/artists'
    | '/cleancut'
    | '/cover-art'
    | '/dmca'
    | '/enhanced-album'
    | '/labels'
    | '/libs'
    | '/lyric-video'
    | '/lyrics'
    | '/mastering'
    | '/motion-art'
    | '/privacy'
    | '/sell-music-online'
    | '/stems'
    | '/super-single'
    | '/terms'
    | '/account/settings'
    | '/auth'
    | '/dev'
    | '/@{$CREATOR_SLUG}/$ALBUM_SLUG'
    | '/account/followed-artists'
    | '/account/liked-songs'
    | '/account/purchases'
    | '/albums/$ALBUM_ID'
    | '/audiolab/help'
    | '/audiolab/sales'
    | '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
    | '/checkout/redirect'
    | '/creators/$CREATOR_ID'
    | '/creators/me'
    | '/oauth2/idpresponse'
    | '/soundkits/$SOUNDKIT_ID'
    | '/tracks/$TRACK_ID'
    | '/@{$CREATOR_SLUG}'
    | '/audiolab'
    | '/fans'
    | '/for-artists'
    | '/upgrade'
    | '/account/settings/billing'
    | '/account/settings/personal'
    | '/account/settings/plan'
    | '/admin/delete-user'
    | '/admin/featured-albums'
    | '/admin/impersonate'
    | '/admin/users'
    | '/audiolab/albums/$ALBUM_ID'
    | '/audiolab/creators/$CREATOR_ID'
    | '/audiolab/releases/$ALBUM_ID'
    | '/audiolab/soundkits/$SOUNDKIT_ID'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/dev/audio-test'
    | '/dev/dd-test'
    | '/dev/global-player-test'
    | '/dev/waveform-test'
    | '/marketplace/albums'
    | '/marketplace/beats'
    | '/marketplace/songs'
    | '/marketplace/soundkits'
    | '/admin'
    | '/audiolab/albums'
    | '/audiolab/releases'
    | '/audiolab/roster'
    | '/marketplace'
    | '/audiolab/tracks/$TRACK_ID/lyrics-video'
    | '/audiolab/tracks/$TRACK_ID'
  id:
    | '__root__'
    | '/'
    | '/audiolab'
    | '/about'
    | '/about-us'
    | '/acceptable-use'
    | '/artists'
    | '/cleancut'
    | '/cover-art'
    | '/dmca'
    | '/enhanced-album'
    | '/labels'
    | '/libs'
    | '/lyric-video'
    | '/lyrics'
    | '/mastering'
    | '/motion-art'
    | '/privacy'
    | '/sell-music-online'
    | '/stems'
    | '/super-single'
    | '/terms'
    | '/account/settings'
    | '/admin/_adminLayout'
    | '/auth/_authLayout'
    | '/dev/_devLayout'
    | '/@{$CREATOR_SLUG}/$ALBUM_SLUG'
    | '/account/followed-artists'
    | '/account/liked-songs'
    | '/account/purchases'
    | '/albums/$ALBUM_ID'
    | '/audiolab/help'
    | '/audiolab/sales'
    | '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
    | '/checkout/redirect'
    | '/creators/$CREATOR_ID'
    | '/creators/me'
    | '/marketplace/_layout'
    | '/oauth2/idpresponse'
    | '/soundkits/$SOUNDKIT_ID'
    | '/tracks/$TRACK_ID'
    | '/@{$CREATOR_SLUG}/'
    | '/audiolab/'
    | '/fans/'
    | '/for-artists/'
    | '/upgrade/'
    | '/account/settings/billing'
    | '/account/settings/personal'
    | '/account/settings/plan'
    | '/admin/_adminLayout/delete-user'
    | '/admin/_adminLayout/featured-albums'
    | '/admin/_adminLayout/impersonate'
    | '/admin/_adminLayout/users'
    | '/audiolab/albums/$ALBUM_ID'
    | '/audiolab/creators/$CREATOR_ID'
    | '/audiolab/releases/$ALBUM_ID'
    | '/audiolab/soundkits/$SOUNDKIT_ID'
    | '/auth/_authLayout/reset-password'
    | '/auth/_authLayout/verify-email'
    | '/dev/_devLayout/audio-test'
    | '/dev/_devLayout/dd-test'
    | '/dev/_devLayout/global-player-test'
    | '/dev/_devLayout/waveform-test'
    | '/marketplace/_layout/albums'
    | '/marketplace/_layout/beats'
    | '/marketplace/_layout/songs'
    | '/marketplace/_layout/soundkits'
    | '/admin/_adminLayout/'
    | '/audiolab/albums/'
    | '/audiolab/releases/'
    | '/audiolab/roster/'
    | '/marketplace/_layout/'
    | '/audiolab/tracks/$TRACK_ID/lyrics-video'
    | '/audiolab/tracks/$TRACK_ID/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AudiolabRouteRoute: typeof AudiolabRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  AboutUsRoute: typeof AboutUsRoute
  AcceptableUseRoute: typeof AcceptableUseRoute
  ArtistsRoute: typeof ArtistsRoute
  CleancutRoute: typeof CleancutRoute
  CoverArtRoute: typeof CoverArtRoute
  DmcaRoute: typeof DmcaRoute
  EnhancedAlbumRoute: typeof EnhancedAlbumRoute
  LabelsRoute: typeof LabelsRoute
  LibsRoute: typeof LibsRoute
  LyricVideoRoute: typeof LyricVideoRoute
  LyricsRoute: typeof LyricsRoute
  MasteringRoute: typeof MasteringRoute
  MotionArtRoute: typeof MotionArtRoute
  PrivacyRoute: typeof PrivacyRoute
  SellMusicOnlineRoute: typeof SellMusicOnlineRoute
  StemsRoute: typeof StemsRoute
  SuperSingleRoute: typeof SuperSingleRoute
  TermsRoute: typeof TermsRoute
  AccountSettingsRouteRoute: typeof AccountSettingsRouteRouteWithChildren
  AdminAdminLayoutRouteRoute: typeof AdminAdminLayoutRouteRouteWithChildren
  AuthAuthLayoutRouteRoute: typeof AuthAuthLayoutRouteRouteWithChildren
  DevDevLayoutRouteRoute: typeof DevDevLayoutRouteRouteWithChildren
  AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute: typeof AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute
  AccountFollowedArtistsRoute: typeof AccountFollowedArtistsRoute
  AccountLikedSongsRoute: typeof AccountLikedSongsRoute
  AccountPurchasesRoute: typeof AccountPurchasesRoute
  AlbumsALBUM_IDRoute: typeof AlbumsALBUM_IDRoute
  AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route: typeof AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route
  CheckoutRedirectRoute: typeof CheckoutRedirectRoute
  CreatorsCREATOR_IDRoute: typeof CreatorsCREATOR_IDRoute
  CreatorsMeRoute: typeof CreatorsMeRoute
  MarketplaceLayoutRoute: typeof MarketplaceLayoutRouteWithChildren
  Oauth2IdpresponseRoute: typeof Oauth2IdpresponseRoute
  SoundkitsSOUNDKIT_IDRoute: typeof SoundkitsSOUNDKIT_IDRoute
  TracksTRACK_IDRoute: typeof TracksTRACK_IDRoute
  AtChar123CREATOR_SLUGChar125IndexRoute: typeof AtChar123CREATOR_SLUGChar125IndexRoute
  FansIndexRoute: typeof FansIndexRoute
  ForArtistsIndexRoute: typeof ForArtistsIndexRoute
  UpgradeIndexRoute: typeof UpgradeIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/super-single': {
      id: '/super-single'
      path: '/super-single'
      fullPath: '/super-single'
      preLoaderRoute: typeof SuperSingleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stems': {
      id: '/stems'
      path: '/stems'
      fullPath: '/stems'
      preLoaderRoute: typeof StemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sell-music-online': {
      id: '/sell-music-online'
      path: '/sell-music-online'
      fullPath: '/sell-music-online'
      preLoaderRoute: typeof SellMusicOnlineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/motion-art': {
      id: '/motion-art'
      path: '/motion-art'
      fullPath: '/motion-art'
      preLoaderRoute: typeof MotionArtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mastering': {
      id: '/mastering'
      path: '/mastering'
      fullPath: '/mastering'
      preLoaderRoute: typeof MasteringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lyrics': {
      id: '/lyrics'
      path: '/lyrics'
      fullPath: '/lyrics'
      preLoaderRoute: typeof LyricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lyric-video': {
      id: '/lyric-video'
      path: '/lyric-video'
      fullPath: '/lyric-video'
      preLoaderRoute: typeof LyricVideoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libs': {
      id: '/libs'
      path: '/libs'
      fullPath: '/libs'
      preLoaderRoute: typeof LibsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labels': {
      id: '/labels'
      path: '/labels'
      fullPath: '/labels'
      preLoaderRoute: typeof LabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enhanced-album': {
      id: '/enhanced-album'
      path: '/enhanced-album'
      fullPath: '/enhanced-album'
      preLoaderRoute: typeof EnhancedAlbumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dmca': {
      id: '/dmca'
      path: '/dmca'
      fullPath: '/dmca'
      preLoaderRoute: typeof DmcaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cover-art': {
      id: '/cover-art'
      path: '/cover-art'
      fullPath: '/cover-art'
      preLoaderRoute: typeof CoverArtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cleancut': {
      id: '/cleancut'
      path: '/cleancut'
      fullPath: '/cleancut'
      preLoaderRoute: typeof CleancutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artists': {
      id: '/artists'
      path: '/artists'
      fullPath: '/artists'
      preLoaderRoute: typeof ArtistsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/acceptable-use': {
      id: '/acceptable-use'
      path: '/acceptable-use'
      fullPath: '/acceptable-use'
      preLoaderRoute: typeof AcceptableUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audiolab': {
      id: '/audiolab'
      path: '/audiolab'
      fullPath: '/audiolab'
      preLoaderRoute: typeof AudiolabRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade/': {
      id: '/upgrade/'
      path: '/upgrade'
      fullPath: '/upgrade/'
      preLoaderRoute: typeof UpgradeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/for-artists/': {
      id: '/for-artists/'
      path: '/for-artists'
      fullPath: '/for-artists/'
      preLoaderRoute: typeof ForArtistsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fans/': {
      id: '/fans/'
      path: '/fans'
      fullPath: '/fans/'
      preLoaderRoute: typeof FansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audiolab/': {
      id: '/audiolab/'
      path: '/'
      fullPath: '/audiolab/'
      preLoaderRoute: typeof AudiolabIndexRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/@{$CREATOR_SLUG}/': {
      id: '/@{$CREATOR_SLUG}/'
      path: '/@{$CREATOR_SLUG}'
      fullPath: '/@{$CREATOR_SLUG}/'
      preLoaderRoute: typeof AtChar123CREATOR_SLUGChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracks/$TRACK_ID': {
      id: '/tracks/$TRACK_ID'
      path: '/tracks/$TRACK_ID'
      fullPath: '/tracks/$TRACK_ID'
      preLoaderRoute: typeof TracksTRACK_IDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/soundkits/$SOUNDKIT_ID': {
      id: '/soundkits/$SOUNDKIT_ID'
      path: '/soundkits/$SOUNDKIT_ID'
      fullPath: '/soundkits/$SOUNDKIT_ID'
      preLoaderRoute: typeof SoundkitsSOUNDKIT_IDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth2/idpresponse': {
      id: '/oauth2/idpresponse'
      path: '/oauth2/idpresponse'
      fullPath: '/oauth2/idpresponse'
      preLoaderRoute: typeof Oauth2IdpresponseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace/_layout': {
      id: '/marketplace/_layout'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creators/me': {
      id: '/creators/me'
      path: '/creators/me'
      fullPath: '/creators/me'
      preLoaderRoute: typeof CreatorsMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creators/$CREATOR_ID': {
      id: '/creators/$CREATOR_ID'
      path: '/creators/$CREATOR_ID'
      fullPath: '/creators/$CREATOR_ID'
      preLoaderRoute: typeof CreatorsCREATOR_IDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/redirect': {
      id: '/checkout/redirect'
      path: '/checkout/redirect'
      fullPath: '/checkout/redirect'
      preLoaderRoute: typeof CheckoutRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2': {
      id: '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
      path: '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
      fullPath: '/audiomack/D6AFDC8EBDFCDC7C93C8D33551D4B5A2'
      preLoaderRoute: typeof AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audiolab/sales': {
      id: '/audiolab/sales'
      path: '/sales'
      fullPath: '/audiolab/sales'
      preLoaderRoute: typeof AudiolabSalesRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/help': {
      id: '/audiolab/help'
      path: '/help'
      fullPath: '/audiolab/help'
      preLoaderRoute: typeof AudiolabHelpRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/albums/$ALBUM_ID': {
      id: '/albums/$ALBUM_ID'
      path: '/albums/$ALBUM_ID'
      fullPath: '/albums/$ALBUM_ID'
      preLoaderRoute: typeof AlbumsALBUM_IDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/purchases': {
      id: '/account/purchases'
      path: '/account/purchases'
      fullPath: '/account/purchases'
      preLoaderRoute: typeof AccountPurchasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/liked-songs': {
      id: '/account/liked-songs'
      path: '/account/liked-songs'
      fullPath: '/account/liked-songs'
      preLoaderRoute: typeof AccountLikedSongsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/followed-artists': {
      id: '/account/followed-artists'
      path: '/account/followed-artists'
      fullPath: '/account/followed-artists'
      preLoaderRoute: typeof AccountFollowedArtistsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/@{$CREATOR_SLUG}/$ALBUM_SLUG': {
      id: '/@{$CREATOR_SLUG}/$ALBUM_SLUG'
      path: '/@{$CREATOR_SLUG}/$ALBUM_SLUG'
      fullPath: '/@{$CREATOR_SLUG}/$ALBUM_SLUG'
      preLoaderRoute: typeof AtChar123CREATOR_SLUGChar125ALBUM_SLUGRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/_devLayout': {
      id: '/dev/_devLayout'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevDevLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_authLayout': {
      id: '/auth/_authLayout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/_adminLayout': {
      id: '/admin/_adminLayout'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAdminLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/settings': {
      id: '/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AccountSettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace/_layout/': {
      id: '/marketplace/_layout/'
      path: '/'
      fullPath: '/marketplace/'
      preLoaderRoute: typeof MarketplaceLayoutIndexRouteImport
      parentRoute: typeof MarketplaceLayoutRoute
    }
    '/audiolab/roster/': {
      id: '/audiolab/roster/'
      path: '/roster'
      fullPath: '/audiolab/roster/'
      preLoaderRoute: typeof AudiolabRosterIndexRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/releases/': {
      id: '/audiolab/releases/'
      path: '/releases'
      fullPath: '/audiolab/releases/'
      preLoaderRoute: typeof AudiolabReleasesIndexRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/albums/': {
      id: '/audiolab/albums/'
      path: '/albums'
      fullPath: '/audiolab/albums/'
      preLoaderRoute: typeof AudiolabAlbumsIndexRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/admin/_adminLayout/': {
      id: '/admin/_adminLayout/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminAdminLayoutIndexRouteImport
      parentRoute: typeof AdminAdminLayoutRouteRoute
    }
    '/marketplace/_layout/soundkits': {
      id: '/marketplace/_layout/soundkits'
      path: '/soundkits'
      fullPath: '/marketplace/soundkits'
      preLoaderRoute: typeof MarketplaceLayoutSoundkitsRouteImport
      parentRoute: typeof MarketplaceLayoutRoute
    }
    '/marketplace/_layout/songs': {
      id: '/marketplace/_layout/songs'
      path: '/songs'
      fullPath: '/marketplace/songs'
      preLoaderRoute: typeof MarketplaceLayoutSongsRouteImport
      parentRoute: typeof MarketplaceLayoutRoute
    }
    '/marketplace/_layout/beats': {
      id: '/marketplace/_layout/beats'
      path: '/beats'
      fullPath: '/marketplace/beats'
      preLoaderRoute: typeof MarketplaceLayoutBeatsRouteImport
      parentRoute: typeof MarketplaceLayoutRoute
    }
    '/marketplace/_layout/albums': {
      id: '/marketplace/_layout/albums'
      path: '/albums'
      fullPath: '/marketplace/albums'
      preLoaderRoute: typeof MarketplaceLayoutAlbumsRouteImport
      parentRoute: typeof MarketplaceLayoutRoute
    }
    '/dev/_devLayout/waveform-test': {
      id: '/dev/_devLayout/waveform-test'
      path: '/waveform-test'
      fullPath: '/dev/waveform-test'
      preLoaderRoute: typeof DevDevLayoutWaveformTestRouteImport
      parentRoute: typeof DevDevLayoutRouteRoute
    }
    '/dev/_devLayout/global-player-test': {
      id: '/dev/_devLayout/global-player-test'
      path: '/global-player-test'
      fullPath: '/dev/global-player-test'
      preLoaderRoute: typeof DevDevLayoutGlobalPlayerTestRouteImport
      parentRoute: typeof DevDevLayoutRouteRoute
    }
    '/dev/_devLayout/dd-test': {
      id: '/dev/_devLayout/dd-test'
      path: '/dd-test'
      fullPath: '/dev/dd-test'
      preLoaderRoute: typeof DevDevLayoutDdTestRouteImport
      parentRoute: typeof DevDevLayoutRouteRoute
    }
    '/dev/_devLayout/audio-test': {
      id: '/dev/_devLayout/audio-test'
      path: '/audio-test'
      fullPath: '/dev/audio-test'
      preLoaderRoute: typeof DevDevLayoutAudioTestRouteImport
      parentRoute: typeof DevDevLayoutRouteRoute
    }
    '/auth/_authLayout/verify-email': {
      id: '/auth/_authLayout/verify-email'
      path: '/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthAuthLayoutVerifyEmailRouteImport
      parentRoute: typeof AuthAuthLayoutRouteRoute
    }
    '/auth/_authLayout/reset-password': {
      id: '/auth/_authLayout/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthAuthLayoutResetPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRouteRoute
    }
    '/audiolab/soundkits/$SOUNDKIT_ID': {
      id: '/audiolab/soundkits/$SOUNDKIT_ID'
      path: '/soundkits/$SOUNDKIT_ID'
      fullPath: '/audiolab/soundkits/$SOUNDKIT_ID'
      preLoaderRoute: typeof AudiolabSoundkitsSOUNDKIT_IDRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/releases/$ALBUM_ID': {
      id: '/audiolab/releases/$ALBUM_ID'
      path: '/releases/$ALBUM_ID'
      fullPath: '/audiolab/releases/$ALBUM_ID'
      preLoaderRoute: typeof AudiolabReleasesALBUM_IDRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/creators/$CREATOR_ID': {
      id: '/audiolab/creators/$CREATOR_ID'
      path: '/creators/$CREATOR_ID'
      fullPath: '/audiolab/creators/$CREATOR_ID'
      preLoaderRoute: typeof AudiolabCreatorsCREATOR_IDRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/albums/$ALBUM_ID': {
      id: '/audiolab/albums/$ALBUM_ID'
      path: '/albums/$ALBUM_ID'
      fullPath: '/audiolab/albums/$ALBUM_ID'
      preLoaderRoute: typeof AudiolabAlbumsALBUM_IDRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/admin/_adminLayout/users': {
      id: '/admin/_adminLayout/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminAdminLayoutUsersRouteImport
      parentRoute: typeof AdminAdminLayoutRouteRoute
    }
    '/admin/_adminLayout/impersonate': {
      id: '/admin/_adminLayout/impersonate'
      path: '/impersonate'
      fullPath: '/admin/impersonate'
      preLoaderRoute: typeof AdminAdminLayoutImpersonateRouteImport
      parentRoute: typeof AdminAdminLayoutRouteRoute
    }
    '/admin/_adminLayout/featured-albums': {
      id: '/admin/_adminLayout/featured-albums'
      path: '/featured-albums'
      fullPath: '/admin/featured-albums'
      preLoaderRoute: typeof AdminAdminLayoutFeaturedAlbumsRouteImport
      parentRoute: typeof AdminAdminLayoutRouteRoute
    }
    '/admin/_adminLayout/delete-user': {
      id: '/admin/_adminLayout/delete-user'
      path: '/delete-user'
      fullPath: '/admin/delete-user'
      preLoaderRoute: typeof AdminAdminLayoutDeleteUserRouteImport
      parentRoute: typeof AdminAdminLayoutRouteRoute
    }
    '/account/settings/plan': {
      id: '/account/settings/plan'
      path: '/plan'
      fullPath: '/account/settings/plan'
      preLoaderRoute: typeof AccountSettingsPlanRouteImport
      parentRoute: typeof AccountSettingsRouteRoute
    }
    '/account/settings/personal': {
      id: '/account/settings/personal'
      path: '/personal'
      fullPath: '/account/settings/personal'
      preLoaderRoute: typeof AccountSettingsPersonalRouteImport
      parentRoute: typeof AccountSettingsRouteRoute
    }
    '/account/settings/billing': {
      id: '/account/settings/billing'
      path: '/billing'
      fullPath: '/account/settings/billing'
      preLoaderRoute: typeof AccountSettingsBillingRouteImport
      parentRoute: typeof AccountSettingsRouteRoute
    }
    '/audiolab/tracks/$TRACK_ID/': {
      id: '/audiolab/tracks/$TRACK_ID/'
      path: '/tracks/$TRACK_ID'
      fullPath: '/audiolab/tracks/$TRACK_ID/'
      preLoaderRoute: typeof AudiolabTracksTRACK_IDIndexRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
    '/audiolab/tracks/$TRACK_ID/lyrics-video': {
      id: '/audiolab/tracks/$TRACK_ID/lyrics-video'
      path: '/tracks/$TRACK_ID/lyrics-video'
      fullPath: '/audiolab/tracks/$TRACK_ID/lyrics-video'
      preLoaderRoute: typeof AudiolabTracksTRACK_IDLyricsVideoRouteImport
      parentRoute: typeof AudiolabRouteRoute
    }
  }
}

interface AudiolabRouteRouteChildren {
  AudiolabHelpRoute: typeof AudiolabHelpRoute
  AudiolabSalesRoute: typeof AudiolabSalesRoute
  AudiolabIndexRoute: typeof AudiolabIndexRoute
  AudiolabAlbumsALBUM_IDRoute: typeof AudiolabAlbumsALBUM_IDRoute
  AudiolabCreatorsCREATOR_IDRoute: typeof AudiolabCreatorsCREATOR_IDRoute
  AudiolabReleasesALBUM_IDRoute: typeof AudiolabReleasesALBUM_IDRoute
  AudiolabSoundkitsSOUNDKIT_IDRoute: typeof AudiolabSoundkitsSOUNDKIT_IDRoute
  AudiolabAlbumsIndexRoute: typeof AudiolabAlbumsIndexRoute
  AudiolabReleasesIndexRoute: typeof AudiolabReleasesIndexRoute
  AudiolabRosterIndexRoute: typeof AudiolabRosterIndexRoute
  AudiolabTracksTRACK_IDLyricsVideoRoute: typeof AudiolabTracksTRACK_IDLyricsVideoRoute
  AudiolabTracksTRACK_IDIndexRoute: typeof AudiolabTracksTRACK_IDIndexRoute
}

const AudiolabRouteRouteChildren: AudiolabRouteRouteChildren = {
  AudiolabHelpRoute: AudiolabHelpRoute,
  AudiolabSalesRoute: AudiolabSalesRoute,
  AudiolabIndexRoute: AudiolabIndexRoute,
  AudiolabAlbumsALBUM_IDRoute: AudiolabAlbumsALBUM_IDRoute,
  AudiolabCreatorsCREATOR_IDRoute: AudiolabCreatorsCREATOR_IDRoute,
  AudiolabReleasesALBUM_IDRoute: AudiolabReleasesALBUM_IDRoute,
  AudiolabSoundkitsSOUNDKIT_IDRoute: AudiolabSoundkitsSOUNDKIT_IDRoute,
  AudiolabAlbumsIndexRoute: AudiolabAlbumsIndexRoute,
  AudiolabReleasesIndexRoute: AudiolabReleasesIndexRoute,
  AudiolabRosterIndexRoute: AudiolabRosterIndexRoute,
  AudiolabTracksTRACK_IDLyricsVideoRoute:
    AudiolabTracksTRACK_IDLyricsVideoRoute,
  AudiolabTracksTRACK_IDIndexRoute: AudiolabTracksTRACK_IDIndexRoute,
}

const AudiolabRouteRouteWithChildren = AudiolabRouteRoute._addFileChildren(
  AudiolabRouteRouteChildren,
)

interface AccountSettingsRouteRouteChildren {
  AccountSettingsBillingRoute: typeof AccountSettingsBillingRoute
  AccountSettingsPersonalRoute: typeof AccountSettingsPersonalRoute
  AccountSettingsPlanRoute: typeof AccountSettingsPlanRoute
}

const AccountSettingsRouteRouteChildren: AccountSettingsRouteRouteChildren = {
  AccountSettingsBillingRoute: AccountSettingsBillingRoute,
  AccountSettingsPersonalRoute: AccountSettingsPersonalRoute,
  AccountSettingsPlanRoute: AccountSettingsPlanRoute,
}

const AccountSettingsRouteRouteWithChildren =
  AccountSettingsRouteRoute._addFileChildren(AccountSettingsRouteRouteChildren)

interface AdminAdminLayoutRouteRouteChildren {
  AdminAdminLayoutDeleteUserRoute: typeof AdminAdminLayoutDeleteUserRoute
  AdminAdminLayoutFeaturedAlbumsRoute: typeof AdminAdminLayoutFeaturedAlbumsRoute
  AdminAdminLayoutImpersonateRoute: typeof AdminAdminLayoutImpersonateRoute
  AdminAdminLayoutUsersRoute: typeof AdminAdminLayoutUsersRoute
  AdminAdminLayoutIndexRoute: typeof AdminAdminLayoutIndexRoute
}

const AdminAdminLayoutRouteRouteChildren: AdminAdminLayoutRouteRouteChildren = {
  AdminAdminLayoutDeleteUserRoute: AdminAdminLayoutDeleteUserRoute,
  AdminAdminLayoutFeaturedAlbumsRoute: AdminAdminLayoutFeaturedAlbumsRoute,
  AdminAdminLayoutImpersonateRoute: AdminAdminLayoutImpersonateRoute,
  AdminAdminLayoutUsersRoute: AdminAdminLayoutUsersRoute,
  AdminAdminLayoutIndexRoute: AdminAdminLayoutIndexRoute,
}

const AdminAdminLayoutRouteRouteWithChildren =
  AdminAdminLayoutRouteRoute._addFileChildren(
    AdminAdminLayoutRouteRouteChildren,
  )

interface AuthAuthLayoutRouteRouteChildren {
  AuthAuthLayoutResetPasswordRoute: typeof AuthAuthLayoutResetPasswordRoute
  AuthAuthLayoutVerifyEmailRoute: typeof AuthAuthLayoutVerifyEmailRoute
}

const AuthAuthLayoutRouteRouteChildren: AuthAuthLayoutRouteRouteChildren = {
  AuthAuthLayoutResetPasswordRoute: AuthAuthLayoutResetPasswordRoute,
  AuthAuthLayoutVerifyEmailRoute: AuthAuthLayoutVerifyEmailRoute,
}

const AuthAuthLayoutRouteRouteWithChildren =
  AuthAuthLayoutRouteRoute._addFileChildren(AuthAuthLayoutRouteRouteChildren)

interface DevDevLayoutRouteRouteChildren {
  DevDevLayoutAudioTestRoute: typeof DevDevLayoutAudioTestRoute
  DevDevLayoutDdTestRoute: typeof DevDevLayoutDdTestRoute
  DevDevLayoutGlobalPlayerTestRoute: typeof DevDevLayoutGlobalPlayerTestRoute
  DevDevLayoutWaveformTestRoute: typeof DevDevLayoutWaveformTestRoute
}

const DevDevLayoutRouteRouteChildren: DevDevLayoutRouteRouteChildren = {
  DevDevLayoutAudioTestRoute: DevDevLayoutAudioTestRoute,
  DevDevLayoutDdTestRoute: DevDevLayoutDdTestRoute,
  DevDevLayoutGlobalPlayerTestRoute: DevDevLayoutGlobalPlayerTestRoute,
  DevDevLayoutWaveformTestRoute: DevDevLayoutWaveformTestRoute,
}

const DevDevLayoutRouteRouteWithChildren =
  DevDevLayoutRouteRoute._addFileChildren(DevDevLayoutRouteRouteChildren)

interface MarketplaceLayoutRouteChildren {
  MarketplaceLayoutAlbumsRoute: typeof MarketplaceLayoutAlbumsRoute
  MarketplaceLayoutBeatsRoute: typeof MarketplaceLayoutBeatsRoute
  MarketplaceLayoutSongsRoute: typeof MarketplaceLayoutSongsRoute
  MarketplaceLayoutSoundkitsRoute: typeof MarketplaceLayoutSoundkitsRoute
  MarketplaceLayoutIndexRoute: typeof MarketplaceLayoutIndexRoute
}

const MarketplaceLayoutRouteChildren: MarketplaceLayoutRouteChildren = {
  MarketplaceLayoutAlbumsRoute: MarketplaceLayoutAlbumsRoute,
  MarketplaceLayoutBeatsRoute: MarketplaceLayoutBeatsRoute,
  MarketplaceLayoutSongsRoute: MarketplaceLayoutSongsRoute,
  MarketplaceLayoutSoundkitsRoute: MarketplaceLayoutSoundkitsRoute,
  MarketplaceLayoutIndexRoute: MarketplaceLayoutIndexRoute,
}

const MarketplaceLayoutRouteWithChildren =
  MarketplaceLayoutRoute._addFileChildren(MarketplaceLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AudiolabRouteRoute: AudiolabRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  AboutUsRoute: AboutUsRoute,
  AcceptableUseRoute: AcceptableUseRoute,
  ArtistsRoute: ArtistsRoute,
  CleancutRoute: CleancutRoute,
  CoverArtRoute: CoverArtRoute,
  DmcaRoute: DmcaRoute,
  EnhancedAlbumRoute: EnhancedAlbumRoute,
  LabelsRoute: LabelsRoute,
  LibsRoute: LibsRoute,
  LyricVideoRoute: LyricVideoRoute,
  LyricsRoute: LyricsRoute,
  MasteringRoute: MasteringRoute,
  MotionArtRoute: MotionArtRoute,
  PrivacyRoute: PrivacyRoute,
  SellMusicOnlineRoute: SellMusicOnlineRoute,
  StemsRoute: StemsRoute,
  SuperSingleRoute: SuperSingleRoute,
  TermsRoute: TermsRoute,
  AccountSettingsRouteRoute: AccountSettingsRouteRouteWithChildren,
  AdminAdminLayoutRouteRoute: AdminAdminLayoutRouteRouteWithChildren,
  AuthAuthLayoutRouteRoute: AuthAuthLayoutRouteRouteWithChildren,
  DevDevLayoutRouteRoute: DevDevLayoutRouteRouteWithChildren,
  AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute:
    AtChar123CREATOR_SLUGChar125ALBUM_SLUGRoute,
  AccountFollowedArtistsRoute: AccountFollowedArtistsRoute,
  AccountLikedSongsRoute: AccountLikedSongsRoute,
  AccountPurchasesRoute: AccountPurchasesRoute,
  AlbumsALBUM_IDRoute: AlbumsALBUM_IDRoute,
  AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route:
    AudiomackD6AFDC8EBDFCDC7C93C8D33551D4B5A2Route,
  CheckoutRedirectRoute: CheckoutRedirectRoute,
  CreatorsCREATOR_IDRoute: CreatorsCREATOR_IDRoute,
  CreatorsMeRoute: CreatorsMeRoute,
  MarketplaceLayoutRoute: MarketplaceLayoutRouteWithChildren,
  Oauth2IdpresponseRoute: Oauth2IdpresponseRoute,
  SoundkitsSOUNDKIT_IDRoute: SoundkitsSOUNDKIT_IDRoute,
  TracksTRACK_IDRoute: TracksTRACK_IDRoute,
  AtChar123CREATOR_SLUGChar125IndexRoute:
    AtChar123CREATOR_SLUGChar125IndexRoute,
  FansIndexRoute: FansIndexRoute,
  ForArtistsIndexRoute: ForArtistsIndexRoute,
  UpgradeIndexRoute: UpgradeIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
